import { Component } from '@angular/core';
import { WidgetBaseComponent } from '../widget-base/widget-base.component';

@Component({
  selector: 'widgets-image-title-text',
  templateUrl: './section-image-title-text.component.html',
  styleUrls: ['./section-image-title-text.component.scss'],
})
export class SectionImageTitleTextComponent extends WidgetBaseComponent {}
